import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
      fetched: false,
      isFetchedIcons: false,
      savingInProgress: false,
      posts:[],
      icons:[]
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    removePostFromState(state, id){
        let posts = [];
        Object.entries(state.posts).forEach(item =>{
            if( Number(item[1].id)!=Number(id)){
                posts.push(item[1]);
            }
        });
        Vue.set(state, 'posts', posts);
    },
  },
  actions: {
    create({ commit, state, dispatch }, payload){
        updateField(state, {path:'post', value:{}});
    },
    update({ commit, state, dispatch }, payload){
      updateField(state, {path:'savingInProgress', value:true});
      return axios.put(this._vm.$apiURL + '/posts/'+payload.id, payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.operation_success'));
          return payload.id;
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        }).finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
        })
    },
    store({ commit, state, dispatch }, payload){
        updateField(state, {path:'savingInProgress', value:true});
        return axios.post(this._vm.$apiURL + '/posts', payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t('common.success_add'));
          return response.data.id;
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
        })
    },
    show({ commit, state, dispatch }, payload){
      updateField(state, {path:'fetched', value:true});
      return axios.get(this._vm.$apiURL + '/posts/'+payload.id)
        .then((response) => {
          updateField(state, {path:'customer', value: response.data});
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'fetched', value:false});
        })
    },
    async get({ commit, state, dispatch }){
        updateField(state, {path:'fetched', value:false});
        return await axios.get(this._vm.$apiURL + '/posts')
        .then((response) => {
          updateField(state, {path:'posts', value:response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
            updateField(state, {path:'fetched', value:true});
        })
    },
    async getIcons({ commit, state, dispatch }){
        updateField(state, {path:'isFetchedIcons', value:false});
        return await axios.get(this._vm.$apiURL + '/post-icons')
        .then((response) => {
          updateField(state, {path:'icons', value:response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
            updateField(state, {path:'isFetchedIcons', value:true});
        })
    },
    remove({ commit, state, dispatch }, payload){
        this._vm.$confirm( {
            title : this._vm.i18n.t('common.confirm'),
            text : this._vm.i18n.t('common.confirm_remove'),
            cancelText : this._vm.i18n.t('common.no'),
            acceptText : this._vm.i18n.t('common.yes')
        } ).then( y =>{
            return axios.delete(this._vm.$apiURL+'/posts/'+payload.id)
                .then(response => {
                    if(response.data.status==='success'){
                        commit('removePostFromState', payload.id);
                        this._vm.$inform( this._vm.i18n.t('common.success_remove') )
                    }
                })
                .catch(error => {
                    dispatch('common/showError', {'error': error}, {root:true});
                });
        }).catch( n => {} );
    },

  }
}
